import { useState } from 'react';
import { ScreenFrame } from '@/components/Screen';
import { SectionCard } from '@/components/DataList';
import { Icon } from '@/components/icons';
import { account } from '@/api/endpoints';
import { errorMessage } from '@/api/client';
import { setToken } from '@/auth/session';
import { Button, FlashMessage, Form, Input } from '@/components/ui';

export function AdminPasswordScreen() {
  const [curPass, setCurPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  async function changePassword() {
    if (!curPass || !newPass) {
      setMsg('أدخل كلمة المرور الحالية والجديدة.');
      return;
    }
    if (newPass.length < 10 || newPass.length > 128) {
      setMsg('كلمة المرور الجديدة يجب أن تكون بين 10 و128 حرفاً.');
      return;
    }
    if (newPass === curPass) {
      setMsg('كلمة المرور الجديدة يجب أن تختلف عن الحالية.');
      return;
    }
    if (newPass !== confirmPass) {
      setMsg('تأكيد كلمة المرور غير مطابق.');
      return;
    }
    setBusy(true);
    const res = await account.changePassword({
      current_password: curPass,
      new_password: newPass,
    });
    setBusy(false);
    setMsg(res.success ? errorMessage(res, 'تم تحديث كلمة المرور.') : errorMessage(res));
    if (res.success) {
      if (typeof res.token === 'string' && res.token) setToken(res.token);
      setCurPass('');
      setNewPass('');
      setConfirmPass('');
    }
  }

  return (
    <ScreenFrame
      mode="admin"
      icon="settings"
      title="تغيير كلمة المرور"
      subtitle="حدّث كلمة مرور حساب الإدارة وأنهِ الجلسات القديمة تلقائياً."
    >
      <SectionCard title="بيانات كلمة المرور" icon={<Icon name="shield" size={24} />}>
        <Form className="password-form" onSubmit={() => void changePassword()}>
          <Input
            label="كلمة المرور الحالية"
            type="password"
            autoComplete="current-password"
            value={curPass}
            onChange={(e) => setCurPass(e.target.value)}
            required
          />
          <Input
            label="كلمة المرور الجديدة"
            hint="من 10 إلى 128 حرفاً."
            type="password"
            autoComplete="new-password"
            maxLength={128}
            value={newPass}
            onChange={(e) => setNewPass(e.target.value)}
            required
          />
          <Input
            label="تأكيد كلمة المرور الجديدة"
            type="password"
            autoComplete="new-password"
            maxLength={128}
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
            required
          />
          <Button type="submit" disabled={busy}>
            <Icon name="check" size={18} />
            {busy ? 'جاري التحديث...' : 'تحديث كلمة المرور'}
          </Button>
        </Form>
        <FlashMessage message={msg} />
      </SectionCard>
    </ScreenFrame>
  );
}
